import { i18next } from '../../i18n/i18n';

export const getPriorityTags = () => [
  i18next.t('CTO'),
  i18next.t('маркетинг'),
  i18next.t('финтех'),
  i18next.t('ai'),
  i18next.t('инвестор'),
];
